import {formatDate} from "./date";

export default class timeUtils{

  /**
   *   1010 => 10:10
   * @param str
   * @returns {boolean}
   */
  static transTimeHM(time) {
    var str = String(time);
    let len = str.length;
    for (let i =len;i< 4;++i){
      str = "0"+str;
    }
    var newStr=timeUtils.insertStr(str,2,":");
    return newStr;
  }

  /**
   *  10:10  => 1010
   * @param
   * @returns {boolean}
   */
  static transTimeHMInt(time) {

    var str = time;
    str = str.replace(":","")
    return parseInt(str);
  }

  /**
   *   20211212 => 2021-12-12
   * @param str
   * @returns {boolean}
   */
  static transDay(time) {
    var str = String(time);

    var newStr=timeUtils.insertStr(str,6,"-");
    newStr =timeUtils.insertStr(newStr,4,"-");
    return newStr;
  }

  /**
   *   2021-12-12  => 20211212
   * @param str
   * @returns {boolean}
   */
  static transDayInt(time) {
    var str = String(time);
    var newStr=str.replace(/-/g, '')
    return parseInt(newStr);
  }

  static insertStr(soure, start, newStr){
    return soure.slice(0, start) + newStr + soure.slice(start);
  }

  //计算两个日期相差的天数
  static  getDaysBetween(dateString1,dateString2){
    var  startDate = Date.parse(dateString1);
    var  endDate = Date.parse(dateString2);
    var days=(endDate - startDate)/(1*24*60*60*1000);
    // alert(days);
    return  Math.floor(days);
  }

  //计算两个日期相差的天数 YYYY-MM-DD 格式

  static  getDaysBetween2(startDayStr,endDayStr){

    var  startDate = new Date(startDayStr);
    var  endDate = new Date(endDayStr);
    let d  = endDate.getTime() - startDate.getTime();

    var days=(endDate.getTime() - startDate.getTime())/(24*3600*1000);
    // alert(days);
    return  Math.floor(days);
  }


  //计算月份
  static monDiff(startTime,endTime){
    var date2Mon;
    var startDate=startTime.getDate()+startTime.getHours()/24+startTime.getMinutes()/24/60;
    var endDate=endTime.getDate()+endTime.getHours()/24+endTime.getMinutes()/24/60;
    if(endDate>=startDate){
      date2Mon=0;
    }else{
      date2Mon=-1;
    }
    return (endTime.getYear-startTime.getYear())*12+endTime.getMonth-startTime.getMonth()+date2Mon;
  }

  //获得一天毫秒数
  static getDayMilSec(){
    return 86400000;
  }
  //获取是周几
  static getWeekDay(date){

    let day = date.getDay();

    return this.getWeekDayByDay(day)
  }
//获取是周几
  static getWeekDayByDay(day){

    if (day ==1){
      return "周一"
    }else if (day == 2){
      return "周二"
    } else if (day == 3){
      return "周三"
    } else if (day == 4){
      return "周四"
    }else if (day == 5){
      return "周五"
    }else if (day == 6){
      return "周六"
    } else if (day == 0){
      return "周日"
    }
  }
  /**
   * 获取周一
   * @param date
   * @returns {Date}
   */
  static getFirstDayOfWeek (date) {
    var day = date.getDay() || 7;
    return new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1 - day);
  };

  /**
   * 获取周一
   * @param date
   * @returns {Date}
   */
  static getFirstDayOfMonth (date) {
    var nowMonth = date.getMonth(); //当前月
    var nowYear = date.getFullYear(); //当前年
    var monthStartDate = new Date(nowYear, nowMonth, 1);
    return monthStartDate;

  };

  /**
   * 获取一天的秒数
   * @returns {number}
   */
  static getDayMs(){
    return 86400000
  }


  /**
   * 获取几天前的日期
   * @param date
   * @returns {Date}
   */
  static getBeforeDayOfDate (date,days) {
    let lm = date.getTime();
    let be = lm - this.getDayMs()*days;
    return new Date(be);

  };



  /**
   * 获取上半年
   * @param date
   * @returns {Date}
   */
  static getFirstDayOfHYear (date) {
    let year = date.getFullYear();

    let f  = year + "-" + "01-" + "01";

    f =new Date(f);

    let l =year + "-" + "06-" + "30";

    l = new Date(l);

    return [f,l];

  };
  /**
   * 获取下半年
   * @param date
   * @returns {Date}
   */
  static getFirstDayOfLYear (date) {
    let year = date.getFullYear();
    let f = year + "-" + "07-" + "01";
    f =new Date(f);
    let l =year + "-" + "12-" + "31";
    l =new Date(l);
    return [f,l];
  };

   /**
   * 获取当前月的第一天和最后一天
   * @param date
   * @returns {Date}
   */
  static getCurrentMouth () {
    // 获取当前日期
    let today = new Date();
    // 获取当前月份的第一天
    let firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    // 获取当前月份的最后一天
    let lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    return [firstDayOfMonth,lastDayOfMonth]
  };

  /**
   * 获取本季度的第一天和最后一天
   * @param date
   * @returns {Date}
   */
  static getCurrentQuarter () {
   // 获取当前日期
   const currentDate = new Date();
   // 判断当前日期所在季度
   const quarter = Math.floor(currentDate.getMonth() / 3) * 3; // 月份除以3向下取整
   console.log(quarter, "quarter");
   // 获取当前日期的年份
   const year = currentDate.getFullYear();
   // // 计算本季度的起始日期
   const startOfQuarter = new Date(year, quarter, 1); // 将当前日期推前一个月作为季度起始日期
   // 计算本季度的结束日期
   const endOfQuarter = new Date(year, startOfQuarter.getMonth() + 3, 0);
    return [startOfQuarter,endOfQuarter]
  };

  /**
   * 获取年份的第一天和最后一天
   * @param date
   * @returns {Date}
   */
  static getCurrentNear () {
    // 获取当前日期
    let currentDate = new Date();
    // 获取当前日期的月份
    let month = currentDate.getMonth() + 1; // 注意：月份从0开始，所以需要加1
    // 判断当前日期所在季度
    let quarter = Math.floor((currentDate.getMonth() + 3) / 3); // 月份除以3向下取整
    console.log(quarter, "quarter");
    // 获取当前日期的年份
    let year = currentDate.getFullYear();
    // 计算本年度的开始日期
    let startOfYear = new Date(year, 0, 1); // 最后一个工作日为年度结束日期
    // 计算本年度的结束日期
    let endOfYear = new Date(year, 11, 31); // 最后一个工作日为年度结束日期
    return [startOfYear,endOfYear]
  };
}



// WEBPACK FOOTER //
// ./src/utils/timeUtils.js